import { MenuIcon } from "../../icons/CommonIcons";
import profileImg from "../../assets/images/Logo-light.png";
import Button from "./Button";
import Image from "./Image.jsx";
import { useEffect, useRef, useState } from "react";
import { clearAllStorage, getStoredItem } from "../../config/storageUtils.js";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider.jsx";
import { useAuth } from "../Auth/AuthProvider.jsx";

const Topbar = ({ toggleSidebar, pageTitle, showLanguageToggle = false }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();
  const { userType, setUserType, setTokenGenerated, setRoleId } = useAuth();

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    await clearAllStorage();
    setUserType(null);
    setTokenGenerated(false);
    setRoleId(null);
    if (userType === "admin" || userType === "superadmin") {
      navigate("/admin", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
    setDropdownOpen(false);
  };

  return (
    <header className="flex items-center justify-between p-4 shadow bg-white sticky top-0 z-10">
      <div className="flex items-center gap-4">
        <Button
          onClick={toggleSidebar}
          className="md:hidden focus:outline-none"
        >
          <MenuIcon />
        </Button>
        <p className="text-sm text-gray-600">
          {language ? "मुख्य पृष्ठ" : "Home"} /{" "}
          <span className="text-theme-color text-sm">{pageTitle}</span>
        </p>
      </div>
      <div className="relative flex items-center" ref={dropdownRef}>
        {/* Language Toggle */}
        {showLanguageToggle && (
          <>
            <div className="flex items-center gap-2 mr-4">
              <span className="text-sm text-gray-700">English</span>

              <button
                type="button"
                onClick={() => setLanguage(!language)}
                className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors
      ${language ? "bg-btn" : "bg-gray-300"}`}
              >
                <span
                  className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform
        ${language ? "translate-x-6" : "translate-x-1"}`}
                />
              </button>

              <span className="text-sm text-gray-700">हिंदी</span>
            </div>
            <div className="h-6 w-px bg-gray-300 mx-3"></div>
          </>
        )}

        {/* Divider */}

        {/* Logout */}
        <Button
          className="block w-full text-left px-4 py-2 text-theme-color"
          onClick={handleLogout}
        >
          {language ? "लॉगआउट" : "Logout"}
        </Button>
      </div>
    </header>
  );
};

export default Topbar;
